import { gql } from "apollo-boost";

export const MEET_SESSION_EVENT_MERGE = gql`
  mutation meetEventMerge(
    $sessionSeqno: Int!
    $eventId: Int!
    $externalEventId: Int!
    $updateSource: String!
    $position: Int
  ) {
    meetEventMerge(
      meetData: {
        sessionSeqno: $sessionSeqno
        eventId: $eventId
        externalEventId: $externalEventId
        updateSource: $updateSource
        position: $position
      }
    ) {
      node {
        seqno
        sessionSeqno
        eventId
        externalEventId
        updateSource
        position
        event {
          distance
          eventDesc
          eventId
          facilityType
          noOfRep
          noOfSets
          sportType
          stroke
          tag
          updateSource
        }
      }
    }
  }
`;

export const MEET_SESSION_EVENT_DELETE = gql`
  mutation meetEventDelete($seqno: Int!) {
    meetEventDelete(seqno: $seqno) {
      status
    }
  }
`;
